import React, { useEffect, useState } from "react";
import { CancelOrder, CancelOrderByAdmin, createdPass, PostOrderAdmin } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { PostUserAdmin, PutUserAdmin } from "../../../../services/UserService";
import { ActiveType } from "../../../../models/Login";
import { PutPartnerAdmin } from "../../../../services/PartnerService";
import { NearbyAttractionItem } from "../../../../models/Partner";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { parseMoneyToNumber } from "../component/moneyInput";

/** Align với bulk update: chỉ cần một trong hai; thiếu phía kia dùng 00:00 / 23:59. */
function normalizeAdminWorkHour(fromWork: string, toWork: string) {
	const from = String(fromWork).trim();
	const to = String(toWork).trim();
	return {
		from: from || (to ? "00:00" : ""),
		to: to || (from ? "23:59" : ""),
	};
}

export default function useUpdatePartnerAdmin(props: { reload?: () => void; id: string }) {
	const { openAlertDialog } = useAlertDialog();
	const updatePartnerAd = async (
		name: string,
		address: string,
		addressText: string,
		note: string,
		lat: string,
		long: string,
		displayName: string,
		displayAddress: string,
		toWork: string,
		fromWork: string,
		price: string,
		insurancePrice: string,
		reviewScore: string,
		reviewQuantity: string,
		locationId: string,
		hotline: string[],
		emailPartner: string,
		stationEmail: string,
		stationCom?: string,
		minimumPayout?: string,
		maximumPayout?: string,
		pubRate?: string,
		rateLimitMax?: string,
		closureExceptionConfig?: object | null,
		feeSmall?: number | null,
		feeMedium?: number | null,
		feeLarge?: number | null,
		imageSmall?: string | null,
		imageMedium?: string | null,
		imageLarge?: string | null,
		mapImage?: string | null,
		nearbyAttractionsContent?: NearbyAttractionItem[] | null,
		stationShowMeetTab?: boolean | null,
		stationShowNearbyTab?: boolean | null,
		meetStationSubtitle?: string | null
	) => {
		const hour = normalizeAdminWorkHour(fromWork, toWork);
		const workSchedule = [
			{
				date: {
					from: "Monday",
					to: "Sunday",
				},
				hour,
			},
		];
		try {
			await PutPartnerAdmin(
				props.id,
				name,
				address,
				addressText,
				note,
				lat,
				long,
				displayName,
				displayAddress,
				parseMoneyToNumber(price),
				parseMoneyToNumber(insurancePrice),
				reviewScore,
				reviewQuantity,
				locationId,
				workSchedule,
				hotline,
				emailPartner,
				stationEmail,
				parseMoneyToNumber(stationCom),
				parseMoneyToNumber(minimumPayout),
				parseMoneyToNumber(maximumPayout),
				parseMoneyToNumber(pubRate),
				undefined, // rateLimitMin
				parseMoneyToNumber(rateLimitMax),
				closureExceptionConfig,
				feeSmall,
				feeMedium,
				feeLarge,
				imageSmall,
				imageMedium,
				imageLarge,
				mapImage,
				nearbyAttractionsContent,
				stationShowMeetTab,
				stationShowNearbyTab,
				meetStationSubtitle
			);
			openAlertDialog?.(AlertType.Success, "Update successfully!", () => {
				props.reload?.();
			});
			return true;
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response?.data?.message || err?.message || "An error has occurred!");
			return false;
		}
	};

	return {
		updatePartnerAd,
	};
}
